import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const token = localStorage.getItem('token');
  const admin = JSON.parse(localStorage.getItem('admin') || 'null');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && (!admin || !allowedRoles.includes(admin.role))) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
